import { configureStore } from '@reduxjs/toolkit';
import loginReducer from 'Components/login/state/loginReducer';
import notificationReducer from 'Components/Common/Notification/state/notificationReducer';
import uiReducer from 'Components/Common/ui/uiReducer';
import permissionReducer from 'Components/Admin/User/Permissions/state/permissionReducer';
import empresaReducer from 'slices/empresaSlice';
import ccfeReducer from 'slices/ccfeSlice';
import cleReducer from 'slices/cleSlice';
import creReducer from 'slices/creSlice';
import dcleReducer from 'slices/dcleSlice';
import feReducer from 'slices/feSlice';
import fexeReducer from 'slices/fexeSlice';
import nceReducer from 'slices/nceSlice';
import ndeReducer from 'slices/ndeSlice';
import nreReducer from 'slices/nreSlice';
import fseReducer from 'slices/fseSlice';
import certReducer from 'slices/certSlice';
import userReducer from 'slices/userSlice';
import appReducer from 'slices/appSlice';

const reducer = {
  auth: loginReducer,
  user: userReducer,
  app: appReducer,
  notification: notificationReducer,
  ui: uiReducer,
  permission: permissionReducer,
  empresa: empresaReducer,
  ccfe: ccfeReducer,
  cle: cleReducer,
  cre: creReducer,
  dcle: dcleReducer,
  fe: feReducer,
  fexe: fexeReducer,
  nce: nceReducer,
  nde: ndeReducer,
  nre: nreReducer,
  fse: fseReducer,
  cert: certReducer,
};

export default configureStore({
  reducer: reducer,
  devTools: true,
});